import * as React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store';
import { TabScreens } from '../../../routes';

export const HomeTabSvg: React.FC = () => {
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen,
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="home"
      width="24"
      height="24"
      viewBox="0 0 64 64"
    >
      {/* Background fill when active */}
      {currentTabScreen === TabScreens.Home && (
        <path
          d="M2 34h8v28a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V34h8L32 4.829"
          fill="var(--main-turquoise)"
          fillOpacity={0.15}
        />
      )}

      {/* Main home icon outline */}
      <path
        fill={currentTabScreen === TabScreens.Home ? 'var(--main-turquoise)' : 'var(--text-color)'}
        d="M40 64h12a2 2 0 0 0 2-2V34h8a2 2 0 0 0 1.414-3.414l-30-30a2 2 0 0 0-2.828 0l-30 30A2 2 0 0 0 2 34h8v28a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V48h12v14a2 2 0 0 0 2 2zM24 44a2 2 0 0 0-2 2v14h-8V32a2 2 0 0 0-2-2H6.828L32 4.829 57.172 30H52a2 2 0 0 0-2 2v28h-8V46a2 2 0 0 0-2-2H24z"
      />
    </svg>
  );
};
